import { createSlice } from "@reduxjs/toolkit"


const logSlice = createSlice({
  name: "log",
  initialState: {

   
   log:null,
    logs: null,
    filteredlogs: null,
    filter: {
      search: null,
      pagination: null,

    },
    filterlogCount: [
      10, 50, 100, 200, 300
    ],
    pagination: null,
      
    selectedpagination:0

  },
  reducers: {

    setLog(state, action) {
        state.log = action.payload
      },
    setLogs(state, action) {
      state.logs = action.payload
    }
    ,
    setFilteredItems(state, action) {
      state.filteredlogs = action.payload
    }
,
    resetLogs(state){
      state.logs = null
      state.filteredlogs = null
      state.filter = {
        search: null,
        pagination: null,
      }
    }
    ,
    setFilter(state, action) {

      if (Array.isArray(action.payload)) {
        action.payload.map(item => {
          state.filter[item.key] = item.value
        })
      }
      else {
        state.filter[action.payload.key] = action.payload.value
      }


    },
    setPagination(state, action) {
      state.pagination = action.payload
    },
      
    setSelectedPagination(state,action){
      state.selectedpagination=action.payload
    }

  },
});

export default logSlice

export const logActions = logSlice.actions;